// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Fbv2I","colBig":"styles_colBig__15ZuW","colSmall":"styles_colSmall__3ge1b"};